import { container } from 'tsyringe';
import { AuthService } from '@/core/auth/services/AuthService';

// no return value since we'll get a page redirect for the login to Azure ADB2C (see login redirect usecase)
export const loginUserUseCase = async (): Promise<void> => {
  const authService = container.resolve<AuthService>('MsalAuthService');
  await authService.login();
};
